


















import Vue from 'vue';
import CompanyInfo from '@/components/CompanyInfo.vue';

export default Vue.extend({
    components: {
        CompanyInfo,
    },
    methods: {
        download() {
            const origin = process.env.NODE_ENV === 'dev' ? process.env.VUE_APP_BASEURL : window.location.origin;
            window.open(`${origin}/ibuildingkit/download/iBuildingKit.zip`);
        },
    },
});
